import { WorkloadsGpuUtilizationSummary } from '@cast/types';
import { toBig } from '@cast/utils';

export type GpuSummaryAggregate = {
  workloadCount: number;
  requestedBytes: number;
  usedBytes: number;
  wastedBytes: number;
};

export const aggregateGpuSummary = (
  workloads: WorkloadsGpuUtilizationSummary[] | undefined,
  totalCount: number
): GpuSummaryAggregate => {
  if (!workloads?.length) {
    return {
      workloadCount: totalCount,
      requestedBytes: 0,
      usedBytes: 0,
      wastedBytes: 0,
    };
  }

  return workloads.reduce<GpuSummaryAggregate>(
    (acc, workload) => {
      const memory = workload.memory;

      return {
        workloadCount: totalCount,
        requestedBytes:
          acc.requestedBytes + toBig(memory?.availableBytes || 0).toNumber(),
        usedBytes: acc.usedBytes + toBig(memory?.usedBytes || 0).toNumber(),
        wastedBytes:
          acc.wastedBytes + toBig(memory?.wastedBytes || 0).toNumber(),
      };
    },
    {
      workloadCount: totalCount,
      requestedBytes: 0,
      usedBytes: 0,
      wastedBytes: 0,
    }
  );
};
